<template>
  <div>
    <a-modal
      width="650px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="项目配置"
      @ok="handleSubmit"
    >
      <a-spin :spinning="loading">
        <a-form
          class="simiot-compact-form"
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit"
        >
          <a-form-item label="CPE型号">
            <a-input :value="data.cpe_model_name" disabled />
          </a-form-item>

          <a-form-item label="通信制式">
            <a-input :value="data.comm_mode_name" disabled />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {
  findAgentPurchaseItemCpeConfigureForm,
  approveCpePurchaseItem
} from '@/api/agent_purchase_item'

export default {
  name: 'ConfigureCpePurchaseItem',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true,
      submitting: false,
      form: this.$form.createForm(this, { name: 'configure_cpe_purchase_item' })
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      findAgentPurchaseItemCpeConfigureForm(this.id).then((res) => {
        if (res.code === 0) {
          this.data = res.data
        }
        this.loading = false
      })
    },

    handleSubmit(e) {
      if (e && e.preventDefault) e.preventDefault()
      if (this.submitting) return
      this.submitting = true
      approveCpePurchaseItem(this.id, {}).then((res) => {
        this.submitting = false
        if (res.code === 0) {
          this.isShow = false
          this.$emit('completed')
        }
      }).catch(() => {
        this.submitting = false
      })
    }
  }
}
</script>
